import React, { useRef, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import rice from '../../../../images/raw_material/rice.png';
const ViewVessel = ({ show, onClose }) => {
    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };
    const tableRef = useRef(null);
    useEffect(() => {
        if (tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    "responsive": true,
                    //   "aaSorting": [],
                    "ordering": false,
                    paging: false,
                    scrollY: "250px", // Set the scroll height here
                    scrollCollapse: true,
                    "language": {
                        "lengthMenu": "Show _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        // "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-12 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        // "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, []);
    return (
        <Modal show={show} size="lg"  >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">View</h3>
                    <Button variant="" type="button" className="close px-6 py-1" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row mb-2">
                        
                        <div className='col-lg-12'>
                            <div className='row'>
                                <div className='col-lg-3 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Cookware</label>
                                    <label className='text-danger fs-6 font-w500'>12-inch Karandi</label>
                                </div>
                                <div className='col-lg-3 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Category</label>
                                    <label className='text-black fs-6 font-w500'>Utensils</label>
                                </div>
                                <div className='col-lg-3 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Sub Category</label>
                                    <label className='text-black fs-6 font-w500'>Karandi</label>
                                </div>
                                 <div className='col-lg-3 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Material</label>
                                    <label className='text-black fs-6 font-w500'>Aluminium</label>
                                </div>
                            </div>
                            <div className='row'>
                                
                                {/* <div className='col-lg-3 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Purchase Qty</label>
                                    <label className='text-black fs-6 font-w500'>24</label>
                                </div> */}
                                <div className='col-lg-3 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Available</label>
                                    <label className='text-black fs-6 font-w500'>10</label>
                                </div>
                                <div className='col-lg-3 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Consumed</label>
                                    <label className='text-black fs-6 font-w500'>14</label>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div className="table-container"  >
                        <table ref={tableRef} className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                            <thead>
                                <tr className="text-muted fw-bold fs-6 gs-0 th_head">
                                    <th className="min-w-100px text-start ">Order Id</th>
                                    <th className="min-w-100px text-start">Consumption Qty/Units</th>
                                    <th className="min-w-100px text-start">Return Date</th>
                                    <th className="min-w-100px text-start">Return Time</th>
                                </tr>
                            </thead>
                            <tbody className="text-gray-600 fw-semibold fs-7">
                                <tr>
                                    <td className="text-start">
                                        <span className="text-black fw-normal fs-7">#AD3566FEAG456</span>
                                    </td>
                                    <td className="text-start">
                                        <span className="text-black fw-normal fs-7">7 No's</span>
                                    </td>
                                    <td className="text-start">
                                        <span className="text-black fw-normal fs-7">23-Aug-2025</span>
                                    </td>
                                    <td className="text-start">
                                        <span className="text-black fw-normal fs-7">12 : 00 AM</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="text-start">
                                        <span className="text-black fw-normal fs-7">#VF3566FEAETR57</span>
                                    </td>
                                    <td className="text-start">
                                        <span className="text-black fw-normal fs-7">7 No's</span>
                                    </td>
                                    <td className="text-start">
                                        <span className="text-black fw-normal fs-7">29-Aug-2025</span>
                                    </td>
                                    <td className="text-start">
                                        <span className="text-black fw-normal fs-7">09 : 00 AM</span>
                                    </td>
                                </tr>
                              
                               
                            </tbody>

                        </table>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default ViewVessel;
